var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndividual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.3496,
    cy: 12.0186,
    r: 11.75,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8337 16.9116V15.8283C16.8337 15.2537 16.6054 14.7026 16.1991 14.2962C15.7927 13.8899 15.2416 13.6616 14.667 13.6616H10.3337C9.75902 13.6616 9.20792 13.8899 8.80159 14.2962C8.39527 14.7026 8.16699 15.2537 8.16699 15.8283V16.9116",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4997 11.495C13.6963 11.495 14.6663 10.5249 14.6663 9.32829C14.6663 8.13167 13.6963 7.16162 12.4997 7.16162C11.3031 7.16162 10.333 8.13167 10.333 9.32829C10.333 10.5249 11.3031 11.495 12.4997 11.495Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndividual);
export default __webpack_public_path__ + "static/media/individual.653503d96614a538aabeb6005375fd21.svg";
export { ForwardRef as ReactComponent };